<div class="agpr-alertGlobalCustomization">
    <agpr-panel header="Alerts.sidebar.headingStyles">
        <agpr-image-style-field
            [id]="id + '.image'"
            [field]="imageField"
            [value]="currentAlert.generalStyles.image"
            (changes)="styleChange($event, alertBlockTypeEnum.IMAGE)"
        ></agpr-image-style-field>
        <agpr-briefing-title-style-field
            [id]="id + '.title'"
            [value]="currentAlert.generalStyles.title"
            [field]="titleField"
            (changes)="styleChange($event, alertBlockTypeEnum.TITLE)"
        ></agpr-briefing-title-style-field>
        <agpr-briefing-date-style-field
            [id]="id + '.dateStyle'"
            [field]="dateStyleField"
            [value]="currentAlert.generalStyles.date"
            (changes)="styleChange($event, alertBlockTypeEnum.DATE)"
        >
        </agpr-briefing-date-style-field>
        <agpr-briefing-text-style-field
            [id]="id + '.body'"
            [field]="textField"
            [value]="currentAlert.generalStyles.text"
            (changes)="styleChange($event, alertBlockTypeEnum.TEXT)"
        ></agpr-briefing-text-style-field>
        <agpr-alert-mention-customization-field
            [id]="id + '.mention'"
            [value]="currentAlert.generalStyles.mention"
            [field]="mentionStyleField"
            [includeNotes]="false"
            (changes)="styleChange($event, alertBlockTypeEnum.ALERT_MENTIONS)"
        ></agpr-alert-mention-customization-field>
    </agpr-panel>
</div>
